<template>
  <v-app>
    <v-navigation-drawer
            v-model="drawer"
            app
            :mini-variant="$vuetify.breakpoint.xsOnly"
    >
      <v-avatar tile size="76">
        <img src="/img/icons/apple-touch-icon-76x76.png" />
      </v-avatar>


      <v-divider></v-divider>

      <v-list
              dense
              nav
      >

        <v-list-item to="/">
          <v-list-item-icon>
            <v-icon>{{$store.state.icons.home}}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


<!--        <v-list-item to="/registeredteams">-->
<!--          <v-list-item-icon>-->
<!--            <v-icon>fas fa-list</v-icon>-->
<!--          </v-list-item-icon>-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title>Registered Teams</v-list-item-title>-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->


        <v-list-item to="/faqs">
          <v-list-item-icon>
            <v-icon>far fa-question-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Faqs</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


        <v-list-item to="/forms">
          <v-list-item-icon>
            <v-icon>fas fa-file-contract</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Forms</v-list-item-title>
          </v-list-item-content>
        </v-list-item>




      </v-list>
    </v-navigation-drawer>
    <v-app-bar app dense flat>
      <v-app-bar-nav-icon @click="drawer=!drawer" ></v-app-bar-nav-icon>
      <v-toolbar-title class="headline text-uppercase">
        <span>{{title}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <NoteBell />
<!--      <v-btn text disabled v-if="loggedIn">Logged In</v-btn>-->
<!--      <v-btn-->
<!--              v-if="!loggedIn"-->
<!--              text-->
<!--              to="/auth/signin"-->
<!--      >-->
<!--        Sign In-->
<!--      </v-btn>-->
<!--      <v-btn color="black"-->
<!--             dark-->
<!--              v-if="!loggedIn"-->
<!--              to="/auth/signup"-->
<!--      >-->
<!--        Sign Up-->
<!--      </v-btn>-->

    </v-app-bar>

    <RouterView />

    <Snackbar />

  </v-app>
</template>

<script>
import Snackbar from "./components/Snackbar";
import BaseBtn from "./components/BaseBtn";
import NoteBell from "./components/NoteBell";

export default {
  name: 'App',
  components: {
    NoteBell,
    BaseBtn,
    Snackbar,
  },
  computed:{
    loggedIn(){
      return this.$store.getters['cognito/isLoggedIn'];
    },
    isReady(){
      return this.$store.state.isReady;
    },
    title(){
      return 'Coates N Hoff 2020'
    }
  },
  watch:{
    loggedIn(n,o){
      if(n && this.$route.path.includes('auth')){
        this.$router.push('/')
      }
      if(n){
        this.$store.dispatch('refreshAuth')
      }
    }
  },
  data: () => ({
    drawer:false,
    versiondialog:false,
    w:'',
    version:'1.2.25',
    orgdialog:false,
    activeorg:false,
    loading:false,
    registrationdialog:false,
    registration: null,
  }),
  mounted(){
    document.addEventListener('swUpdated', this.showRefreshUI);
    document.addEventListener('offline', this.showOffline);
    //this.$store.dispatch('getRegistrationList',this.$store.state.eventId)
  },
  methods:{
    showOffline(){
      console.log('Offline')
    },
    showRefreshUI (e) {
      this.$store.commit('setNewContent',true)
      // My code to show the refresh UI banner/snackbar goes here.
    },
    refreshGo(){


    },
    checkVersion(){
      let em = this;
      let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      };
      let args = {
        headers:headers,
        method:'get'
      };
      fetch(this.$store.state.url+'versionv2/textappy2',args)
              .then((response) => response.json())
              .then((response) => {
                em.$store.commit('setVersion',response.string)
              })
    },

    loadOrg(item){
      if(this.$store.state.org.partkey!==item.partkey){
        this.activeorg=item
        this.orgdialog=true
      } else {
        this.$router.push('/account')
      }
    },
    confirmLoadOrg(){
      //sets the 'default o new org, then loads default
      let args;
      let em = this;
      em.loading=true;
      args = {
        url:this.$store.state.url + 'api/orgs/setdefault',
        method:"POST",
        data:{
          orgkey:this.activeorg.partkey
        }
      }
      this.$store.dispatch('fetch',args).then(data=>{
        em.$store.dispatch('getAppData')
        em.loading=false
        em.activeorg=false
        em.orgdialog=false
        em.$router.push('/account')
      })
    }
  },
  beforeDestroy () {
    document.removeEventListener('swUpdated', this.showRefreshUI);
  },
};
</script>
